// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container-modal {
  padding: 1rem;
  background-color: white;
}
.form-container-modal .header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form-container-modal .header-row h6 {
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.form-container-modal .field-row-modal {
  display: flex;
}
.form-container-modal .field-row-modal ion-item {
  flex-grow: 1;
  margin-bottom: 0.5rem;
}
.form-container-modal .field-row-modal div {
  flex-grow: 1;
  padding: 0 1rem;
  margin-bottom: 0.5rem;
}
.form-container-modal .main-buttons {
  justify-content: center;
  padding: 0 0.75rem;
  flex-direction: row;
  margin-top: 2rem;
}
.form-container-modal .main-buttons button {
  margin: 5px;
}
@media (max-width: 767px) {
  .form-container-modal .main-buttons {
    flex-direction: column;
  }
  .form-container-modal .main-buttons button {
    margin: 5px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/entities/modal-endereco-entidade/modal-endereco-entidade.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AACI;EACE,mBAAA;EACA,gBAAA;AACN;AAGE;EACE,aAAA;AADJ;AAGI;EACE,YAAA;EACA,qBAAA;AADN;AAII;EACE,YAAA;EACA,eAAA;EACA,qBAAA;AAFN;AAME;EACE,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;AAMI;EACE,WAAA;AAJN;AAOI;EAVF;IAWI,sBAAA;EAJJ;EAMI;IACE,aAAA;EAJN;AACF","sourcesContent":[".form-container-modal {\n  padding: 1rem;\n  background-color: white;\n\n  .header-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    h6 {\n      margin-bottom: 1rem;\n      margin-top: 1rem;\n    }\n  }\n\n  .field-row-modal {\n    display: flex;\n\n    ion-item {\n      flex-grow: 1;\n      margin-bottom: 0.5rem;\n    }\n\n    div {\n      flex-grow: 1;\n      padding: 0 1rem;\n      margin-bottom: 0.5rem;\n    }\n  }\n\n  .main-buttons {\n    justify-content: center;\n    padding: 0 0.75rem;\n    flex-direction: row;\n    margin-top: 2rem;\n\n    button {\n      margin: 5px;\n    }\n\n    @media (max-width: 767px) {\n      flex-direction: column;\n\n      button {\n        margin: 5px 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
